import React, { useState, useEffect } from "react";
import debounce from "lodash.debounce";
import ButtonSolid from "../Buttons/ButtonMedium/ButtonBorderedMd";
import ButtonBorderedSm from "../Buttons/ButtonSmall/ButtonBorderedSm";
import "./searchandfilter.css";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import Multiselect from "multiselect-react-dropdown";
import "bootstrap-daterangepicker/daterangepicker.css";

import {
  CaretDownIcon,
  SelectMenu,
  SearchInput,
  toaster,
  Popover,
  Position,
  Menu,
  Ul,
  Link,
  Li,
  Pane,
  majorScale,
  Button,
} from "evergreen-ui";
const SearchAndFilter = ({
  FilterData,
  closefilter,
  manageByShowOrNot,
  searchFucntion,
}) => {
  const [inputValue, setinputValue] = useState();
  const [showInputValue, setshowInputValue] = useState();
  const [showFilterData, setshowFilterData] = useState(false);
  // --------------posted on date filter------------------
  const [postedOnDateState, setStatepostedOnDateState] = useState({
    postedOnStart: moment(),
    postedOnend: moment(),
  });
  const { postedOnStart, postedOnend } = postedOnDateState;
  const [postedOnStartdate, setpostedOnStartdate] =
    useState(""); /*  startdate  */
  const [postedOnEnddate, setpostedOnEnddate] = useState(""); /*  end tdate  */
  const handleCallbackforPostedOn = (postedOnStart, postedOnend) => {
    setStatepostedOnDateState({ postedOnStart, postedOnend });
    setpostedOnStartdate(postedOnStart.format("YYYY-MM-DD"));
    setpostedOnEnddate(postedOnend.format("YYYY-MM-DD"));
  };

  // --------------closing on date filter------------------
  const [closingOnDateState, setStateclosingOnDateState] = useState({
    closingOnStart: moment(),
    closingOnend: moment(),
  });
  const { closingOnStart, closingOnend } = closingOnDateState;
  const [closingOnStartdate, setclosingOnStartdate] =
    useState(""); /*  startdate  */
  const [closingOnEnddate, setclosingOnEnddate] =
    useState(""); /*  end tdate  */
  const handleCallbackforClosingOn = (closingOnStart, closingOnend) => {
    setStateclosingOnDateState({ closingOnStart, closingOnend });
    setclosingOnStartdate(closingOnStart.format("YYYY-MM-DD"));
    setclosingOnEnddate(closingOnend.format("YYYY-MM-DD"));
  };

  const [communityOptions, setcommunityOptions] = useState([]);

  const [manageOptions, setmanageOptions] = useState([
    { name: "MAN 7", id: 7 },
  ]);

  const [communitySelectedData, setcommunitySelectedData] = useState([]);
  const [manageBySelectedData, setmanageBySelectedData] = useState([]);
  // ----------------community handlers------------------------------
  const OnSelectCommunity = (selectedList, selectedItem) => {
    setcommunitySelectedData([...selectedList]);
  };

  const OnRemoveCommunity = (selectedList, removedItem) => {
    setcommunitySelectedData([...selectedList]);
  };
  const CommunityDelete = (val) => {
    const filterData = communitySelectedData.filter((e) => e.id != val);
    setcommunitySelectedData(filterData);
  };

  // ----------------Managed By handlers------------------------------

  const OnSelectManaged = (selectedList, selectedItem) => {
    setmanageBySelectedData([...selectedList]);
  };

  const OnRemoveManaged = (selectedList, removedItem) => {
    setmanageBySelectedData([...selectedList]);
  };
  const ManagedDelete = (val) => {
    const filterData = manageBySelectedData.filter((e) => e.id != val);
    setmanageBySelectedData(filterData);
  };
  // ---------------Clear Filter--------------------------------

  const ClearAllFilter = () => {
    FilterData();
    setcommunitySelectedData("");
    setmanageBySelectedData("");
    setclosingOnStartdate("");
    setclosingOnEnddate("");
    setpostedOnStartdate("");
    setpostedOnEnddate("");
    setinputValue();
    setshowInputValue();
    setshowFilterData(false);
    setinputValue("");
    searchFucntion("");
  };
  const customMultiselectData = {
    multiselectContainer: {
      marginTop: "4px",
      marginBottom: "12px",
      background: "white",
      width: "256px",
    },
    searchBox: {
      Height: "32px",
      background: "white",
      width: "256px",
    },
    inputField: {
      background: "white",
      width: "240px",
      fontSize: "12px",
      fontWeight: "400",
    },
    chips: {
      background: "var(--BaseLightColor)",
      borderRadius: "4px",
      fontSize: "12px",
      color: "var(--TextDarkColor)",
    },
    optionContainer: {
      border: "2px solid #ECEBEC",
      overflowY: "scroll",
      height: "100px",
      // marginBottom: "10px",
    },
    option: {
      fontWeight: "400",
      fontSize: "12px",
      lineHeight: "0px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    groupHeading: {},
  };

  const ApllyHandler = () => {
    setshowFilterData(true);
    let communityIds = [];
    let managedByIds = [];
    for (let x of communitySelectedData) {
      communityIds.push(x.id);
    }
    for (let x of manageBySelectedData) {
      managedByIds.push(x.id);
    }

    FilterData(
      communityIds,
      managedByIds,
      closingOnStartdate,
      closingOnEnddate,
      postedOnStartdate,
      postedOnEnddate
    );
  };

  const getAllCommunities = () => {
    fetch(process.env.REACT_APP_API_URL + "/api/vendor/allcommunities", {
      method: "POST",
    })
      .then((d) => d.json())
      .then((res) => {
        setcommunityOptions(res.response);
      })
      .catch((err) => console.log("e", err));
  };

  const debouncedChangeHandler = () => {
    setshowInputValue(inputValue);
    searchFucntion(inputValue);
  };

  useEffect(() => {
    getAllCommunities();
  }, []);

  return (
    <div className="SrearchAndFilterMainDiv">
      <div className="SrearchAndFilterSubMainDiv">
        <div className="searchbarDivForIcon">
          <img
            src="./images/stratum/search-icon.svg"
            alt=""
            className="serchIconSearch"
          />
          <SearchInput
            placeholder={" |  Search for Community, RFQ No, RFQ title "}
            height={40}
            value={inputValue}
            style={{ width: "solid 2px yellow" }}
            className="searchBar"
            onChange={(e) => {
              setinputValue(e.target.value);
            }}
          />
          <div className="sbtnid">
            {/* <ButtonBorderedSm
              text={"Search"}
              buttonHandler={debouncedChangeHandler}
            /> */}
            <Button
              className="serchMainBtn poppinFont"
              marginRight={16}
              onClick={() => {
                debouncedChangeHandler();
              }}
              width={100}
              height={40}
            >
              Search
            </Button>
          </div>
        </div>

        <Popover
          // minHeight={300}
          position={Position.BOTTOM_LEFT}
          content={({ close }) => (
            <Pane>
              <div className="filterLstMain">
                <div className="filterLst">
                  <p htmlFor="">COMMUNITY</p>
                  {communityOptions && communityOptions.length > 0 && (
                    <Multiselect
                      options={communityOptions}
                      selectedValues={communitySelectedData} // Preselected value to persist in dropdown
                      onSelect={OnSelectCommunity}
                      onRemove={OnRemoveCommunity}
                      displayValue="name"
                      closeIcon={"cancel"}
                      style={customMultiselectData}
                    />
                  )}
                </div>
                {manageByShowOrNot && (
                  <div className="filterLst">
                    <p htmlFor="">MANAGED BY</p>
                    <Multiselect
                      options={manageOptions}
                      selectedValues={manageBySelectedData} // Preselected value to persist in dropdown
                      onSelect={OnSelectManaged}
                      onRemove={OnRemoveManaged}
                      displayValue="name"
                      closeIcon={"cancel"}
                      style={customMultiselectData}
                    />
                  </div>
                )}
                <div className="filterLst">
                  <p htmlFor="">POSTED ON</p>
                  <DateRangePicker
                    initialSettings={{
                      startDate: postedOnStart.toDate(),
                      endDate: postedOnend.toDate(),
                      maxDate: moment().toDate(),
                      opens: "left",
                      alwaysShowCalendars: true,

                      ranges: {
                        Today: [moment().toDate(), moment().toDate()],
                        Yesterday: [
                          moment().subtract(1, "days").toDate(),
                          moment().subtract(1, "days").toDate(),
                        ],
                        "Last 7 Days": [
                          moment().subtract(6, "days").toDate(),
                          moment().toDate(),
                        ],
                        "Last 30 Days": [
                          moment().subtract(29, "days").toDate(),
                          moment().toDate(),
                        ],
                        "This Month": [
                          moment().startOf("month").toDate(),
                          moment().endOf("month").toDate(),
                        ],
                        "Last Month": [
                          moment()
                            .subtract(1, "month")
                            .startOf("month")
                            .toDate(),
                          moment().subtract(1, "month").endOf("month").toDate(),
                        ],
                      },
                    }}
                    onCallback={handleCallbackforPostedOn}
                  >
                    <div
                      id="reportrange"
                      className="rounded"
                      style={{
                        cursor: "pointer",
                        padding: "8px",
                      }}
                    >
                      {!postedOnStartdate && !postedOnEnddate ? (
                        <span>{`${moment().format(
                          "DD/MM/YYYY"
                        )} - ${moment().format("DD/MM/YYYY")}`}</span>
                      ) : (
                        <span>{`${moment(
                          postedOnStartdate,
                          "YYYY-MM-DD"
                        ).format("DD/MM/YYYY")} - ${moment(
                          postedOnEnddate,
                          "YYYY-MM-DD"
                        ).format("DD/MM/YYYY")}`}</span>
                      )}
                      <i className="fa-solid fa-calendar-days "></i>&nbsp;
                    </div>
                  </DateRangePicker>
                </div>
                {closefilter && (
                  <div className="filterLst">
                    <p htmlFor="">CLOSING ON</p>
                    <DateRangePicker
                      initialSettings={{
                        startDate: closingOnStart.toDate(),
                        endDate: closingOnend.toDate(),
                        maxDate: moment().toDate(),
                        opens: "left",
                        alwaysShowCalendars: true,
                        ranges: {
                          Today: [moment().toDate(), moment().toDate()],
                          Yesterday: [
                            moment().subtract(1, "days").toDate(),
                            moment().subtract(1, "days").toDate(),
                          ],
                          "Last 7 Days": [
                            moment().subtract(6, "days").toDate(),
                            moment().toDate(),
                          ],
                          "Last 30 Days": [
                            moment().subtract(29, "days").toDate(),
                            moment().toDate(),
                          ],
                          "This Month": [
                            moment().startOf("month").toDate(),
                            moment().endOf("month").toDate(),
                          ],
                          "Last Month": [
                            moment()
                              .subtract(1, "month")
                              .startOf("month")
                              .toDate(),
                            moment()
                              .subtract(1, "month")
                              .endOf("month")
                              .toDate(),
                          ],
                        },
                      }}
                      onCallback={handleCallbackforClosingOn}
                    >
                      <div
                        id="reportrange"
                        className="rounded"
                        style={{
                          cursor: "pointer",
                          padding: "8px",
                        }}
                      >
                        {!closingOnStartdate && !closingOnEnddate ? (
                          <span>{`${moment().format(
                            "DD/MM/YYYY"
                          )} - ${moment().format("DD/MM/YYYY")}`}</span>
                        ) : (
                          <span>{`${moment(
                            closingOnStartdate,
                            "YYYY-MM-DD"
                          ).format("DD/MM/YYYY")} - ${moment(
                            closingOnEnddate,
                            "YYYY-MM-DD"
                          ).format("DD/MM/YYYY")}`}</span>
                        )}
                        <i className="fa-solid fa-calendar-days "></i>&nbsp;
                      </div>
                    </DateRangePicker>
                  </div>
                )}
                <div className="filterbtnDiv">
                  <button
                    onClick={() => {
                      ApllyHandler();

                      close();
                    }}
                    className="filterApply"
                  >
                    Apply
                  </button>{" "}
                  <button
                    className="filterReset"
                    onClick={() => ClearAllFilter()}
                  >
                    Clear
                  </button>
                </div>
              </div>
            </Pane>
          )}
        >
          <Button
            className="filterMainBtn"
            // width={184}
            height={40}
            // appearance="minimal"
          >
            <div
              onClick={() => {
                ClearAllFilter();
                setshowFilterData(false);
              }}
              className="iconsFilterTextWrapper"
            >
              <img src="./images/stratum/filterLeftSvg.svg" alt="" />
              <span className="filterMargin">Filters</span>
              <img src="./images/stratum/filterRightSvg.svg" alt="" />
            </div>
          </Button>
        </Popover>
      </div>
      <div className="fiterdataDiv">
        <div className="selectedFilterData">
          {showFilterData &&
            communitySelectedData &&
            communitySelectedData.map((e) => {
              return (
                <div
                  type="button"
                  onClick={() => {
                    CommunityDelete(e.id);
                  }}
                  style={{ width: "max-content", marginLeft: "10px" }}
                >
                  {e.name} X
                </div>
              );
            })}

          {showFilterData &&
            manageBySelectedData &&
            manageBySelectedData.map((e) => {
              return (
                <div
                  type="button"
                  onClick={() => {
                    ManagedDelete(e.id);
                  }}
                >
                  {e.name} X
                </div>
              );
            })}
          {/* <div>Hello1</div>
          <div>Hello2</div>
          <div>Hello3</div>
          <div>Hello4</div> */}
          {showFilterData && postedOnStartdate && postedOnEnddate && (
            <div
              type="button"
              onClick={() => {
                setpostedOnStartdate("");
                setpostedOnEnddate("");
              }}
            >
              {`${moment(postedOnStartdate).format("ll")} -
                ${moment(postedOnEnddate).format("ll")} X`}
            </div>
          )}
          {showFilterData && closingOnStartdate && closingOnEnddate && (
            <div
              type="button"
              onClick={() => {
                setclosingOnStartdate("");
                setclosingOnEnddate("");
              }}
            >
              {`${moment(closingOnStartdate).format("ll")} -
                ${moment(closingOnEnddate).format("ll")} X`}
            </div>
          )}
          {/* {showInputValue && showInputValue && (
            <div
              type="button"
              onClick={() => {
                setinputValue("");
                setshowInputValue("");
              }}
              style={{ width: "max-content", marginLeft: "10px" }}
            >
              {showInputValue} X
            </div>
          )} */}
        </div>
        {(showFilterData && communitySelectedData.length) ||
        manageBySelectedData.length ||
        postedOnStartdate.length ||
        showInputValue ||
        closingOnStartdate.length ? (
          <>
            {/* <ButtonBorderedSm text={"Clear"} buttonHandler={ClearAllFilter} />
            <ButtonBorderedSm text={"Apply"} buttonHandler={ApllyHandler} /> */}
            <div className="fiterClearDiv" onClick={() => ClearAllFilter()}>
              Clear
            </div>
            <div className="fiterClearDiv" onClick={() => ApllyHandler()}>
              Apply
            </div>
          </>
        ) : (
          <div></div>
        )}
      </div>
    </div>
  );
};

export default SearchAndFilter;
